import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { NgForm } from "@angular/forms";

import { ActivatedRoute, Router } from "@angular/router";
import { BrokerService } from "@core/services/broker.service";
import { OperadoraService } from "@core/services/operadora.service";
import { PlanoService } from "@core/services/plano.service";
import { TipoItemService } from "@core/services/tipo-item.service";
import { AuthenticationService } from "app/auth/service";
import { BrokerInterface } from "app/module/broker-interface";
import { OperadoraInterface } from "app/module/operadora-interface";
import { PlanoInterface } from "app/module/plano-interface";
import { TipoItemInterface } from "app/module/tipo-item-interface";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";

@Component({
	selector: "app-form-sistema",
	templateUrl: "./form-plano.component.html",
	styleUrls: ["./form-plano.component.scss"],
})
export class FormPlanoComponent implements OnInit {
	@ViewChild('cadastroForm') cadastroForm: NgForm;
	planoInterface: PlanoInterface;
	operadoras: OperadoraInterface[];
	loading: boolean = false;
	href: any;
	contentHeader: object;
	brokers: BrokerInterface;
	tipoItems: TipoItemInterface;
	erro: boolean = false;

	constructor(
		private operadoraService: OperadoraService,
		private tipoItemService: TipoItemService,
		private route: ActivatedRoute,
		private planoService: PlanoService,
		private brokerService: BrokerService,
		private _router: Router
	) { }

	ngOnInit() {
		this.planoInterface = {
			id_plano: this.route.snapshot.params.id,
			id_tipo_item: 0,
			plano: null,
			id_status: 1,
			valor_mensal: null,
			pacote: null,
			valor_ativacao: null,
			valor_cancelar: null,
			valor_reativacao: null,
			id_broker_operadora: 0,
			id_broker: 0,
			id_operadora: 0,
			id_contrato: null,
			valor_max: null,
			valor_min: null,
			id_tipo_fluxo: 0,
		}

		this.contentHeader = {
			headerTitle: this.planoInterface.id_plano ? "Editar Plano" : "Cadastrar Plano",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Plano",
						isLink: false,
					},
					{
						name: this.planoInterface.id_plano ? "Editar" : "Cadastrar",
						isLink: false,
					},
				],
			},
		};

		this.brokerService.get().subscribe(
			(response) => {
				(this.brokers = response)
			},
			(error) => console.log(error)
		)

		this.operadoraService.get().subscribe(
			(response) => {
				(this.operadoras = response)
			},
			(error) => console.log(error)
		)

		this.tipoItemService.get().subscribe(
			(response) => {
				(this.tipoItems = response)
			},
			(error) => console.log(error)
		)

		if (this.planoInterface.id_plano) {

			this.planoService.getOne(this.planoInterface.id_plano).subscribe(
				(response) => {
					this.planoInterface = response[0]
				},
				(error) => console.log(error)
			)

		}
	}

	public submitForm(data: NgForm) {
		this.erro = false;
		this.loading = true;

		if (this.planoInterface.id_tipo_fluxo == 0 || this.planoInterface.id_tipo_item == 0 || this.planoInterface.id_operadora == 0 || this.planoInterface.id_broker == 0) this.erro = true;

		if (data.form.valid === true && !this.erro) {

			this.planoInterface.id_tipo_item = Number(this.planoInterface.id_tipo_item);
			this.planoInterface.id_broker = Number(this.planoInterface.id_broker);
			this.planoInterface.id_operadora = Number(this.planoInterface.id_operadora);
			this.planoInterface.id_tipo_fluxo = Number(this.planoInterface.id_tipo_fluxo);

			//POST
			if (!this.planoInterface.id_plano) {
				this.planoService.post(this.planoInterface).subscribe(
					(res) => {
						if (res.id_plano) {
							this.loading = false;
							Swal.fire({
								title: "Plano cadastrado!",
								text: "O item foi cadastrado com sucesso.",
								icon: "success",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#161D31',
							}).then(() => {
								this._router.navigate(['plano'])
							});
						} else {
							this.msgErroInterno()
						}
					},
					(error) => {
						console.log(error);
						this.msgErroInterno()
					}
				);
			} else {
				this.planoService.put(this.planoInterface).subscribe(
					(res) => {

						if (res) {
							this.loading = false;
							Swal.fire({
								title: "Plano atualizado!",
								text: "O item foi atualizado com sucesso.",
								icon: "success",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#161D31',
							}).then(() => {
								this._router.navigate(['plano'])
							});
						} else {
							this.msgErroInterno()
						}
					},
					(error) => {
						console.log(error);
						this.msgErroInterno()
					}
				);
			}
		}

		if (this.erro) {
			this.loading = false;
			Swal.fire({
				title: "Erro!",
				text: "Preencha os campos broker, tipo item e tipo fluxo.",
				icon: "error",
				confirmButtonText: "Confirmar",
				confirmButtonColor: '#ef6767',
			});
		}
	}
	sanitizeInput(event: Event) {
		const input = event.target as HTMLInputElement;
		input.value = input.value.replace(/[^0-9]/g, '');
	}
	msgErroInterno() {
		this.loading = false;
		Swal.fire({
			title: "Erro!",
			text: "Ocorreu um erro interno.",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	// ngOnDestroy() {
	//   this.routeSub.unsubscribe();
	// }
}
